// extracted by mini-css-extract-plugin
module.exports = {"container":"SelectedTag_container__2tBf6","name":"SelectedTag_name__2mH2J","deleteButton":"SelectedTag_deleteButton__2LKeD","sending":"SelectedTag_sending__3eBlG"};